export const validateUgandanId = (idNumber) => {
    let nationalIdOrPassportRegex = /^[A-Z]{2}[A-Z0-9]{12}$/;

    if (nationalIdOrPassportRegex.test(idNumber)) {
        return null;
    } else {
        return 'Enter a valid National Id Number';
    }
};
